import styled, { keyframes } from 'styled-components';
import { unthemed } from 'tokens';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	padding: 0 16px;
	box-sizing: border-box;
`;

export const MoonWrapper = styled.div`
	display: flex;
`;

const textShimmer = keyframes`
	0% { background-position: 200% center; }
	100% { background-position: -200% center; }
`;

export const ShimmerCaption = styled.div<{ fontSize: number; marginTop: number }>`
	font-family: 'Inter', sans-serif;
	font-size: ${(p) => p.fontSize}px;
	font-weight: 400;
	line-height: 1.3;
	background: linear-gradient(
		90deg,
		${unthemed.gray[100]}55 0%,
		${unthemed.gray[100]}55 38%,
		${unthemed.gray[100]} 50%,
		${unthemed.gray[100]}55 62%,
		${unthemed.gray[100]}55 100%
	);
	background-size: 200% 100%;
	animation: ${textShimmer} 2.8s linear infinite;
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	color: transparent;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-break: break-word;
	margin-top: ${(p) => p.marginTop}px;
	max-width: 100%;
	text-align: center;
`;

// Static caption — same typography as ShimmerCaption but without the progress
// ripple. Used for terminal states (error) where no progress is being made.
export const Caption = styled.div<{ fontSize: number; marginTop: number }>`
	font-family: 'Inter', sans-serif;
	font-size: ${(p) => p.fontSize}px;
	font-weight: 400;
	line-height: 1.3;
	color: ${unthemed.gray[100]};
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-break: break-word;
	margin-top: ${(p) => p.marginTop}px;
	max-width: 100%;
	text-align: center;
`;
